<template>
  <div class="newheadershipment d-flex justify-content-center m-0 mb-4">
    <div 
      class="newheadershipment__col1 col-2 d-flex justify-content-end align-items-center" 
      :class="$route.query.mode === 'OCEAN' ? 'ml-5' : null">
      <img :src="dataHeader.img" class="newheadershipment__image" />
    </div>
    <div 
      class="newheadershipment__col2" 
      :class="$route.query.mode !== 'LAND' ? 'col-9' : 'col-5'">
      <p class="pdetail__title">RFQ - {{ $route.query.mode }}</p>
      <h1>{{dataHeader.shipmenttype}}
        <span v-if="(dataHeader.shipmenttype === 'Barge'
                || dataHeader.shipmenttype === 'LCT')
                && dataHeader.containerType">
                - {{ dataHeader.containerType }}
        </span>
      </h1>
      <p class="pdetail__title">{{dataHeader.text}}</p>
      <div v-if="$route.query.mode !== 'LAND'
                && dataHeader.shipmenttype !== 'Barge'
                && dataHeader.shipmenttype !== 'LCT'"
          class="d-flex align-items-center newheadershipment__detail mt-2">
        <div class="d-flex align-items-center pdetail__headerborder col-4">
          <div class="col-5 text-center">
            <p class="pdetail__p1">Origin</p>
            <p class="pdetail__p2">{{ dataHeader.origin ? dataHeader.origin.name : '-' }}</p>
          </div>
          <img class="col-2" src="@/assets/image/icon/arrow-circle-right.svg" style="height: 20px;" alt="">
          <div class="col-5 text-center">
            <p class="pdetail__p1">Destination</p>
            <p class="pdetail__p2">{{ dataHeader.destination ? dataHeader.destination.name : '-' }}</p>
          </div>
        </div>
        <div class="pdetail__headerborder col-2 text-center">
          <p class="pdetail__p1">Route Type</p>
          <p class="pdetail__p2">{{ dataHeader.routeType ? dataHeader.routeType.text : '-' }}</p>
        </div>
        <div v-if="dataHeader.InfoShipment" class="pdetail__headerborder col-2 text-center">
          <p class="pdetail__p1">{{ dataHeader.InfoShipment[0].title }}</p>
          <p class="pdetail__p2">{{ parseFloat(dataHeader.InfoShipment[0].value).toLocaleString() }}</p>
        </div>
        <div v-if="dataHeader.InfoShipment" class="pdetail__headerborder col-2 text-center">
          <p class="pdetail__p1">{{ dataHeader.InfoShipment[1].title }}</p>
          <p class="pdetail__p2">{{ dataHeader.InfoShipment[1].value.toLocaleString() }} {{ dataHeader.shipmenttype === 'Ocean Breakbulk' ? 'Tons' : 'Kg' }}</p>
        </div>
        <div v-if="dataHeader.InfoShipment" class="pdetail__headerborder col-2 text-center">
          <p class="pdetail__p1">{{ dataHeader.InfoShipment[2].title }}</p>
          <p class="pdetail__p2">{{ dataHeader.InfoShipment[2].value.toLocaleString() }} CBM</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {name: 'header-shipment-type',
  props: {
    dataHeader: Object
  }
}
</script>

<style lang="scss">
.pdetail {
  &__headerborder {
    @media only screen and (min-width: 1536px) {
      padding: 1rem;
    }
    padding: 0.4rem;
    border-right: 1px solid #1D3354;
  }
  &__title {
    @media only screen and (min-width: 1536px) {
      font-size: 14px !important;
    }
    color: #DADEE2 !important;
    font-size: 12px !important;
  }
  &__p1 {
    @media only screen and (min-width: 1536px) {
      font-size: 12px !important;
    }
    color: #DADEE2 !important;
    font-size: 11px !important;
  }
  &__p2 {
    @media only screen and (min-width: 1536px) {
      font-size: 14px !important;
    }
    color: #fff;
    font-size: 13px !important;
    font-weight: 400 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/requestShipment/newRequestShipment/HeaderShipmentRfq.vue